import { X, Loader2 } from "lucide-react"
import { Button } from "@/components/ui/button"

interface ConfirmationModalProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    title: string
    description: string
    confirmText: string
    confirmVariant?: "default" | "destructive" | "primary"
    isLoading?: boolean
}

export function ConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    description,
    confirmText,
    confirmVariant = "primary",
    isLoading = false
}: ConfirmationModalProps) {
    if (!isOpen) return null

    return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
        <div className="bg-white rounded-xl shadow-xl w-[500px] max-w-[90%] relative overflow-hidden p-6 animate-in fade-in zoom-in-95 duration-200">
        <div className="flex justify-between items-start mb-2">
            <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-500 transition-colors">
            <X size={24} />
            </button>
        </div>
        
        <p className="text-gray-600 mb-8 text-[15px]">{description}</p>

        <div className="flex justify-end gap-3">
            <Button variant="outline" onClick={onClose} disabled={isLoading} className="border-gray-300 text-gray-700 font-medium px-4">
            Cancel
            </Button>
            <Button
                onClick={onConfirm}
                disabled={isLoading}
                variant={confirmVariant === 'destructive' ? 'destructive' : 'default'}
                className={confirmVariant === 'primary' ? "bg-[#D91F27] hover:bg-[#b81a21] text-white font-medium px-4 gap-2" : "font-medium px-4 gap-2"}
            >
                {confirmText}
                {isLoading && <Loader2 size={16} className="animate-spin" />}
            </Button>
        </div>
        </div>
    </div>
    )
}
